import { render, staticRenderFns } from "./CommissionsInquire.vue?vue&type=template&id=6589949a&scoped=true&"
import script from "./CommissionsInquire.vue?vue&type=script&lang=js&"
export * from "./CommissionsInquire.vue?vue&type=script&lang=js&"
import style0 from "./CommissionsInquire.vue?vue&type=style&index=0&id=6589949a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6589949a",
  null
  
)

export default component.exports